import {Amount, BillingCycle, BillingCycles, PlanKind, PlanKinds, PlanType, PlanTypes} from "@/app/lib/pricing/types";
import store from "@/app/api/store/paddle-stores";

export type PricingPlan = {
    type: PlanType;
    kind: PlanKind;
    billing: BillingCycle;
    name: string;
    priceId: string;
};

const p = store.products;

export const PricingPlans: PricingPlan[] = [
    {
        type: PlanTypes.foundation,
        kind: PlanKinds.acoustic,
        billing: BillingCycles.monthly,
        name: p.foundation.acoustic.monthly.name,
        priceId: p.foundation.acoustic.monthly.id
    },
    {
        type: PlanTypes.foundation,
        kind: PlanKinds.acoustic,
        billing: BillingCycles.yearly,
        name: p.foundation.acoustic.yearly.name,
        priceId: p.foundation.acoustic.yearly.id
    },
    {
        type: PlanTypes.foundation,
        kind: PlanKinds.electronic,
        billing: BillingCycles.monthly,
        name: p.foundation.electronic.monthly.name,
        priceId: p.foundation.electronic.monthly.id
    },
    {
        type: PlanTypes.foundation,
        kind: PlanKinds.electronic,
        billing: BillingCycles.yearly,
        name: p.foundation.electronic.yearly.name,
        priceId: p.foundation.electronic.yearly.id
    },
    {
        type: PlanTypes.pro,
        kind: PlanKinds.acoustic,
        billing: BillingCycles.monthly,
        name: p.pro.acoustic.monthly.name,
        priceId: p.pro.acoustic.monthly.id
    },
    {
        type: PlanTypes.pro,
        kind: PlanKinds.acoustic,
        billing: BillingCycles.yearly,
        name: p.pro.acoustic.yearly.name,
        priceId: p.pro.acoustic.yearly.id
    },
    {
        type: PlanTypes.pro,
        kind: PlanKinds.electronic,
        billing: BillingCycles.monthly,
        name: p.pro.electronic.monthly.name,
        priceId: p.pro.electronic.monthly.id
    },
    {
        type: PlanTypes.pro,
        kind: PlanKinds.electronic,
        billing: BillingCycles.yearly,
        name: p.pro.electronic.yearly.name,
        priceId: p.pro.electronic.yearly.id
    }
];

export function getPricingPlan(priceId: string): PricingPlan | undefined {
    if (priceId == null) {
        throw new Error(`Invalid priceId: ${priceId}`)
    }
    return PricingPlans.find(p => p.priceId === priceId);
}

export function changingPlanBillingCycle(from: PricingPlan, to: PricingPlan): boolean {
    return from.billing !== to.billing;
}

export function changingPriceBillingCycle(fromPriceId: string, toPriceId: string): boolean {
    const from = getPricingPlan(fromPriceId);
    if (from == null) {
        throw new Error(`Invalid priceId: ${fromPriceId}`);
    }
    const to = getPricingPlan(toPriceId);
    if (to == null) {
        throw new Error(`Invalid priceId: ${toPriceId}`);
    }
    return changingPlanBillingCycle(from, to);
}

export function formatBalance(balanceInCents: number): string {
    return (balanceInCents / 100).toFixed(2);
}

export function hasAmount(amount: Amount): boolean {
    return amount.amount !== '0' && amount.amount !== '';
}

export function formatAmount(amount: Amount): string {
    return (Number(amount.amount) / 100).toFixed(2) + ' ' + amount.currency;
}
